import BaseSetup from '@/components/BaseSetup';
import useDiscussionService from '@/services/DiscussionService';
import { Reactive } from '@/utils/decorators';
import { ref } from 'vue';

export type SharedDiscussionsEmits = {};
export type SharedDiscussionsProps = {};

export default class SharedDiscussionsSetup extends BaseSetup {

	static readonly defaultProps = {};

	readonly _discussionsList = ref<HTMLElement>();
	readonly _discussions = ref<(OrionChat)[]>([]);

	readonly discussionService = useDiscussionService();
	@Reactive private readonly state = {
		firstFetch: false,
		displayDiscussionList: false,
	};

	get displayDiscussionList () { return this.state.displayDiscussionList }
	get displayDiscussionWrapper () {
		if (this.ui.onLayoutNavBottom)
			return !this.displayDiscussionList && !this.discussionService?.openedDiscussions.length;
		else return !this.displayDiscussionList;
	}

	get publicInstance () {
		return {
			_discussionsList: () => this._discussionsList,
			show: () => this.show(),
			hide: () => this.hide(),
			toggle: () => this.toggle(),
		};
	}

	constructor (
		private props: SharedDiscussionsProps,
		private emits: SharedDiscussionsEmits,
	) {
		super();
	}

	protected onMounted () {
		this.discussionService?.startSignalRMessage();
		this.discussionService?.getUnreadMessagesIdsAsync(),
		this.discussionService?.registerDiscussionsComponent(this.publicInstance);
		this.registerBusEvent('checkUnreadMessagesInDom', (discussionId) => {
			this._discussions.value.find(x => x.getDiscussionId() === discussionId)?.checkUnreadMessagesInDom();
		});
	}

	protected onBeforeUnmount (): void {
		this.discussionService?.leaveDiscussions();
		this.discussionService?.stopSignalRMessage();
	}

	private async exeFirstFetchAsync () {
		if (!this.state.firstFetch) {
			this.state.firstFetch = true;
			await this.discussionService?.chat.fetchDiscussionsAsync();
		}
	}

	show () {
		this.state.displayDiscussionList = true;
		this.exeFirstFetchAsync();
	}

	hide () {
		this.state.displayDiscussionList = false;
	}

	private toggle () {
		this.state.displayDiscussionList = !this.state.displayDiscussionList;
	}

}
